import { makeStyles } from '@material-ui/core'

const useStyles = makeStyles((theme) => ({
  root: {
    display: 'grid',
    gridTemplateColumns: '1fr 0.26fr',
    columnGap: 15,
    height: `calc(100vh - 80px)`,
    padding: '16px',
    width: '100%',
    [theme.breakpoints.down('sm')]: {
      gridTemplateColumns: '1fr',
      height: 'auto'
    }
  },
  rootSmall: { gridTemplateColumns: '1fr', position: 'relative' },
  root1280: { gridTemplateColumns: '1fr 0.41fr' },
  root1440: { gridTemplateColumns: '1fr 0.38fr' },
  root1680: { gridTemplateColumns: '1fr 0.33fr' },

  stickyDiv: {
    margin: '-23px -96px -23px -96px',
    height: '80px',
    background: theme.palette.grey[800],
    position: 'sticky',
    top: 65,
    left: 130,
    marginBottom: 10,
    zIndex: 5,
    [theme.breakpoints.down('sm')]: {
      margin: '-22px -16px 0px -16px',
      overflow: 'visible',
      alignSelf: 'unset',
      top: 50
    }
  },
  stepContainer: {
    display: 'flex',
    width: '100%',
    height: '100%',
    alignItems: 'center',
    justifyContent: 'center'
  },
  left: {
    overflowY: 'auto',
    paddingBottom: 36,
    display: 'flex',
    flexDirection: 'column',
    height: '100%',
    scrollbarWidth: 'none' /* Firefox */,
    msOverflowStyle: 'none' /* IE and Edge */,
    '&::-webkit-scrollbar': {
      display: 'none' /* Chrome, Safari, Opera */
    }
  },
  Right: {
    position: 'sticky',
    marginTop: 0,
    alignSelf: 'start',
    height: '100%',
    overflowY: 'auto',
    display: 'flex',
    flexDirection: 'column',
    marginLeft: 12,
    zIndex: 4,
    scrollbarWidth: 'none' /* Firefox */,
    msOverflowStyle: 'none' /* IE and Edge */,
    '&::-webkit-scrollbar': {
      display: 'none' /* Chrome, Safari, Opera */
    },
    [theme.breakpoints.down('sm')]: {
      position: 'relative',
      height: 'auto',
      overflow: 'visible',
      marginLeft: 0
    }
  },
  priceDetailsContainer: {
    display: 'flex',
    flexDirection: 'column',
    background: theme.palette.grey[200],
    padding: 10,
    margin: '10px 0px',
    borderRadius: 8
  },
  greyText: { color: theme.palette.grey[600] },
  continueText: {
    color: theme.palette.primary.contrastText,
    fontSize: 16,
    fontWeight: 500
  },
  cancelText: {
    fontWeight: 500
  },

  btn: { width: '100%', margin: '6px 0px' },
  blackText: { fontWeight: 600, color: theme.palette.text.primary },
  header: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    marginTop: 8
  },
  blueText: {
    color: theme.palette.info.main,
    fontWeight: 600,
    alignSelf: 'center'
  },
  blueIcon: {
    color: theme.palette.info.main,
    fontSize: 40,
    marginRight: 4,
    alignSelf: 'center'
  },

  noResultFound: {
    position: 'fixed',
    top: 100,
    left: 0,
    width: '100%',
    display: 'flex',
    paddingTop: theme.spacing(10),
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    textAlign: 'center'
  },
  buttons: {
    [theme.breakpoints.down('sm')]: {
      position: 'sticky',
      bottom: 0,
      background: theme.palette.primary.contrastText,
      zIndex: 20
    }
  },
  img: {
    width: '15%',
    [theme.breakpoints.down('sm')]: {
      width: '25%'
    }
  },
  noResults: {
    marginTop: 16,
    fontWeight: 500,
    fontSize: 20,
    [theme.breakpoints.down('sm')]: {
      fontSize: 12
    }
  }
}))
export default useStyles
